export enum STORAGE {
  HISTORICAL_DATA = "squirrelHistoricalData"
}
